import React from "react";
import { Box, BoxProps } from "@mui/material";

const GlassPanel: React.FC<BoxProps> = ({ children, sx, ...rest }) => (
  <Box
    sx={{
      background: "var(--glass)",
      backdropFilter: "blur(20px)",
      WebkitBackdropFilter: "blur(20px)",
      border: "1px solid var(--border-hi)",
      borderRadius: "var(--radius-lg)",
      p: { xs: 2, md: 2.5 },
      position: "relative",
      overflow: "hidden",
      "&::before": {
        content: '""',
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        height: 1,
        background: "linear-gradient(90deg, transparent, rgba(255,255,255,0.08), transparent)",
      },
      ...sx,
    }}
    {...rest}
  >
    {children}
  </Box>
);

export default GlassPanel;
